import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
import styled from 'styled-components';
import { initNewLegend } from './NewLegend';
let init = false;

const setChartDefaults = (Chart, fontColor, fontFamily) => {
  if (!init) {
    initNewLegend(Chart);
    init = true;
  }

  Chart.defaults.global.defaultFontColor = fontColor;
  Chart.defaults.global.defaultFontFamily = fontFamily || Chart.defaults.global.defaultFontFamily;
};

const GraphWrapper = styled.div.withConfig({
  displayName: "ChartGraph__GraphWrapper",
  componentId: "aw60g1-0"
})(["background:", ";padding-top:0.25rem;border-radius:1px;"], props => props.theme.palette.background.paper);

const assignRef = (passedRef, chartInstance) => {
  if (passedRef && typeof passedRef !== 'function') {
    passedRef.current = chartInstance;
  } else if (typeof passedRef === 'function') {
    passedRef(chartInstance);
  }
};

export const ChartGraph = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(({
  Chart,
  data,
  type,
  options
}, ref) => {
  const theme = useTheme(); // HTML <canvas> element

  const chartRef = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  const [chartData, setChartData] = useState(data);
  const [chartOptions, setChartOptions] = useState(options); // build chart function

  const buildChart = useCallback(newData => {
    // CanvasRenderingContext2D
    const myChartRef = chartRef.current && chartRef.current.getContext('2d');
    const newChartInstance = myChartRef && new Chart(myChartRef, {
      data: newData,
      type,
      options: options || undefined
    }); // assign ref explicitly to the chartInstance

    assignRef(ref, newChartInstance);
    setChartInstance(newChartInstance);
  }, [type, options, chartRef, ref, setChartInstance, Chart]);
  const updateChart = useCallback((newData, newOptions) => {
    if (chartInstance && chartInstance.data && (newData !== chartData || newOptions !== chartOptions)) {
      // update labels, datasets, options
      chartInstance.data.labels = [];
      chartInstance.data.datasets = [];
      chartInstance.update();
      chartInstance.data = newData;
      chartInstance.options = chartOptions ? Chart.helpers.configMerge(chartOptions, newOptions) : newOptions;
      chartInstance.update();
      setChartData(newData);
      setChartOptions(newOptions);
    }
  }, [chartData, chartInstance, chartOptions, Chart.helpers]);
  useEffect(() => {
    setChartDefaults(Chart, theme.palette.text.primary, theme.typography.fontFamily);
  }, [Chart, theme]);
  useEffect(() => {
    if (!chartInstance) {
      buildChart(data);
    }

    if (chartInstance) {
      updateChart(data, options);
    }
  }, [data, options, chartInstance, updateChart, buildChart]);
  return /*#__PURE__*/React.createElement(GraphWrapper, null, /*#__PURE__*/React.createElement("canvas", {
    id: "myChart",
    ref: chartRef
  }));
}));
export default ChartGraph;